var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilefooterCustomerCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#111324;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32019",
    "data-name": "Group 32019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74381",
    "data-name": "Path 74381",
    className: "cls-1",
    d: "M469.42,307.13A80.94,80.94,0,0,1,452,344.92a75.75,75.75,0,0,1-43.91,25.55c-5.16,1-5.55.64-5.55-4.59V226.24c0-5.36.26-5.57,5.36-4.66a75.87,75.87,0,0,1,60.73,60.63c.18,1,.46,2,.68,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74382",
    "data-name": "Path 74382",
    className: "cls-1",
    d: "M426.64,200.72c0,11.36.11,11.29-8.14,9a79.09,79.09,0,0,0-11.58-2.4c-3.25-.37-4.38-1.66-4.63-5a155.5,155.5,0,0,0-48.6-103.13,154.62,154.62,0,0,0-94.28-43.2A158.42,158.42,0,0,0,90.89,176.64a173.21,173.21,0,0,0-4,26.42c-.22,2.69-1.26,4-3.92,4.2a58,58,0,0,0-15.75,3.57c-3.93,1.48-4.79.25-4.7-3.57a175.43,175.43,0,0,1,30.37-97.43A178,178,0,0,1,217.12,30.47,182.19,182.19,0,0,1,423.67,176.94,168.16,168.16,0,0,1,426.64,200.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74383",
    "data-name": "Path 74383",
    className: "cls-1",
    d: "M86.75,296.19v68.94c0,6.2-.34,6.41-6.59,5.12a75.73,75.73,0,0,1,1.38-148.72c4.91-.86,5.25-.63,5.25,4.45Q86.75,261.08,86.75,296.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74384",
    "data-name": "Path 74384",
    className: "cls-1",
    d: "M289.51,471.57H256.6a23.33,23.33,0,0,1-23.68-23V448a23.33,23.33,0,0,1,23.16-23.49h67.75c7.14,0,9.68,2.59,9.79,9.79,0,5.36,0,5.36,5.44,4.3a61.12,61.12,0,0,0,47.39-48.51c.54-3,1.63-4.47,4.65-4.54,2.2,0,4.38-.32,6.57-.37,5.61-.15,6,.3,5.13,6a77.74,77.74,0,0,1-63.07,63.68c-4.5.72-6.56,2.08-6.24,7.15.46,7.14-2.48,9.64-9.75,9.66C312.32,471.57,300.91,471.57,289.51,471.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74385",
    "data-name": "Path 74385",
    className: "cls-1",
    d: "M129.66,296.14v66.29c0,10.72.5,8.93-9.29,9.07H106.76c-6.36,0-6.38,0-6.38-6.21V226.12c0-6,0-6.09,6.16-6.11h17.13c5.72,0,6,.18,6,5.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74386",
    "data-name": "Path 74386",
    className: "cls-1",
    d: "M388.86,296.12c0,23.22-.12,46.53,0,69.81,0,4.48-1.39,5.91-5.79,5.66a158.6,158.6,0,0,0-18,0c-4.61.29-5.69-1.6-5.66-5.86.12-32.77,0-65.55,0-98.33,0-14,.1-28.1,0-42.14,0-4,1.37-5.48,5.35-5.36,6,.23,12,0,18,0s6,.14,6,5.84Q388.87,261,388.86,296.12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilefooterCustomerCare);
export default __webpack_public_path__ + "static/media/Mobilefooter_customer_care.e01e1e787318b6de388bf6a9b1a9127d.svg";
export { ForwardRef as ReactComponent };